// extracted by mini-css-extract-plugin
export default {"lntDivider_removeMargins":"styles_lnt-divider_remove-margins__0Qr0Q"};